import { render, staticRenderFns } from "./PostAnswers.vue?vue&type=template&id=08fa9e8e&scoped=true&"
import script from "./PostAnswers.vue?vue&type=script&lang=js&"
export * from "./PostAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fa9e8e",
  null
  
)

export default component.exports